module.exports = __webpack_public_path__ + "img/ICONE-ROND3.4b4a3835.svg";